import { jsx, jsxs } from "react/jsx-runtime";
function UnarrivedTime() {
    return /*#__PURE__*/ jsxs("svg", {
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsx("rect", {
                x: "17.5",
                y: "16.5",
                width: "14",
                height: "2.5",
                rx: "1.25",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "16.5",
                cy: "17.5",
                r: "3",
                fill: "#EBEFF5"
            }),
            /*#__PURE__*/ jsx("rect", {
                width: "14",
                height: "2.5",
                rx: "1.25",
                transform: "matrix(-1 0 0 1 27.5 25)",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "3",
                cy: "3",
                r: "3",
                transform: "matrix(-1 0 0 1 31.5 23.5)",
                fill: "#EBEFF5"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M51.2607 30.3896L51.2607 23.6012",
                stroke: "#EBEFF5",
                strokeWidth: "2.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M57.2607 30.3896L57.2607 19.7221",
                stroke: "#EBEFF5",
                strokeWidth: "2.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M63.2607 30.3896L63.2607 16.8127",
                stroke: "white",
                strokeWidth: "2.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M16.5 64.5771L16.5 57.7887",
                stroke: "#EBEFF5",
                strokeWidth: "2.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M22.5 64.5771L22.5 53.9096",
                stroke: "#EBEFF5",
                strokeWidth: "2.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M28.5 64.5771L28.5 51.0002",
                stroke: "#EBEFF5",
                strokeWidth: "2.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M59.2485 5.70312H9.37034C8.26916 5.70312 7.37646 6.59581 7.37646 7.697V70.0058C7.37646 71.1069 8.26916 71.9996 9.37034 71.9996H59.2485C60.3497 71.9996 61.2424 71.1069 61.2424 70.0058V7.697C61.2424 6.59582 60.3497 5.70312 59.2485 5.70312Z",
                fill: "#E8EDF5"
            }),
            /*#__PURE__*/ jsx("path", {
                opacity: "0.4",
                d: "M59.1471 5.70312H42.9204V23.8562H61.141V7.697C61.141 6.59582 60.2483 5.70312 59.1471 5.70312Z",
                fill: "#D8DEEA"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M61.141 23.8562L42.9233 5.70312V21.8623C42.9233 22.9635 43.816 23.8562 44.9172 23.8562H61.141Z",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M15.6636 28.9072H40.5248",
                stroke: "#AFB9C9",
                strokeWidth: "2.71267",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M15.6636 37.1943H32.2377",
                stroke: "#AFB9C9",
                strokeWidth: "2.71267",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("rect", {
                x: "45.8101",
                y: "41.3379",
                width: "30.6621",
                height: "30.6621",
                rx: "15.3311",
                fill: "#D8DEEA"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "61.1409",
                cy: "56.6682",
                r: "11.4983",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M61.1411 50.0986V57.3644L64.9739 60.5019",
                stroke: "#A8B4C7",
                strokeWidth: "2.19015",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("rect", {
                x: "14.4414",
                y: "43.5869",
                width: "26.3326",
                height: "14.4556",
                rx: "1.49541",
                fill: "#D8DEEA"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "39.855",
                cy: "37.185",
                r: "2.07177",
                fill: "#C6CEDE"
            })
        ]
    });
}
export { UnarrivedTime as default };
